/**
 * Resolve a friendly page-title string for the current location.
 *
 * Order of preference:
 *   1. If a route in `routes` matches `pathname` exactly, return its
 *      configured `title`. This lets each module own its display
 *      name (e.g. URL `/expense` → "Expense"; URL `/analytics` →
 *      "Analytics") without the header inheriting whatever ugly
 *      slug ends up in the URL.
 *   2. Otherwise fall back to deriving the title from the pathname
 *      — strip the leading slash, swap `_` for spaces, join nested
 *      segments with " > ". This is still useful for transient or
 *      detail routes that don't have a `dashboardItem` entry.
 *   3. Root path → "dashboard".
 */
export function getLocationName({ pathname }, routes = []) {
  if (pathname === undefined || pathname === null) {
    return "unknown";
  }

  // Route-title lookup — the cleanest source of truth when the
  // current URL maps to a known route. Trims a trailing slash so
  // "/expense/" still matches the "/expense" entry.
  const cleanPath = pathname.replace(/\/+$/, "") || "/";
  const matched = routes.find((r) => r?.path === cleanPath);
  if (matched?.title) return matched.title;

  // Fallback — derive from the URL itself.
  let p = pathname.startsWith("/") ? pathname.substring(1) : pathname;
  const name01 = p.split("/").filter(Boolean).join(" > ");
  const name = name01.split("_").filter(Boolean).join(" ");

  if (name === "") return "dashboard";
  return name;
}
